import React from "react";
import { MultiSelectProvider } from "../hooks/use-multi-select";
import Dropdown from "./dropdown";

var MultiSelect = props => /*#__PURE__*/React.createElement(MultiSelectProvider, {
  props: props
}, /*#__PURE__*/React.createElement("div", {
  className: "rmsc " + (props.className || "multi-select")
}, /*#__PURE__*/React.createElement(Dropdown, null)));

export default MultiSelect;
//# sourceMappingURL=index.js.map